import React, { type ReactNode, type FC } from 'react'

interface IProps {
  answers: IAnswer[]
  answersLeft: number
  handleSaveAnswer: (answer: IAnswer) => void
  userHasAnswerToThis: (answer: IAnswer) => boolean
  getClassName: (answer: IAnswer, classes: IClasses) => string
  children: ReactNode
}

interface IClasses {
  base: string
  hover: string
  isWaiting: string
  isCorrect: string
  isWrong: string
}

const ImageAnswers: FC<IProps> = ({ answers, answersLeft, handleSaveAnswer, getClassName, children }) => {
  return (
    <div className={'grid grid-cols-1 gap-4 lg:grid-cols-2 lg:gap-6 lg:overflow-auto lg:pr-4'}>
      {answers.map((option, index) => (
        <figure
          key={option.id}
          className={getClassName(option, {
            base: `text-base group grid grid-cols-2 aspect-[2.80] border border-duskBlack  transition-colors lg:text-xl`,
            hover: ' hover:text-sunriseGoldDarker hover:border-sunriseGoldDarker cursor-pointer',
            isWaiting: 'border-sunriseGoldDarker bg-sunriseGold text-duskBlack',
            isCorrect: 'border-forestGreen bg-forestGreen text-pureWhite',
            isWrong: 'border-sunsetRed bg-sunsetRed text-pureWhite',
          })}
          onClick={() => {
            handleSaveAnswer(option)
          }}
        >
          <img
            className='h-full w-full object-cover'
            src={option.image}
            alt='option'
          />
          <figcaption className='text-center p-cta flex justify-center items-center'>{option.label}</figcaption>
        </figure>
      ))}
      {children}
    </div>
  )
}

export default ImageAnswers
